// Celebrity personas. The live list comes from GET /celebs/catalog (managed in
// the backend admin at /celebs/admin); the static list below is the instant
// fallback — first paint, prerender and offline/dev without a backend.
import {useSyncExternalStore} from 'react';
import {apiGetWithRetry} from '../api/client';

export const PERSONAS = [
    {
        id: 'PUTIN_BEREZKI',
        name: 'Владимир Путин',
        image: '/celebratory/Владимир Путин.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/putin.mp4'
    },
    {
        id: 'EANDREEVA',
        name: 'Екатерина Андреева',
        image: '/celebratory/Екатерина Андреева.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/andreeva.mp4'
    },
    {
        id: 'BURUNOV_FIREPLACE',
        name: 'Сергей Бурунов',
        image: '/celebratory/sergei-burunov.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/burunov.mp4'
    },
    {
        id: 'URGANT',
        name: 'Иван Ургант',
        image: '/celebratory/Иван Ургант.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/urgant.mp4'
    },
    {
        id: 'MALAHOV',
        name: 'Андрей Малахов',
        image: './celebratory/andrei-malahov.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/malahov.mp4'
    },
    {
        id: 'KIRKOROV',
        name: 'Филипп Киркоров',
        image: '/celebratory/Фил Киркоров.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/kirkorov.mp4'
    },
    {
        id: 'DMITRIENKO',
        name: 'Ваня Дмитриенко',
        image: '/celebratory/Ваня Дмитриенко.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/dmitrienko.mp4'
    },
    {
        id: 'HARLAMOV',
        name: 'Гарик Харламов',
        image: '/celebratory/Гарик Харламов.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/harlamov.mp4'
    },
    {
        id: 'TRUMP',
        name: 'Дональд Трамп',
        image: '/celebratory/Дональд Трамп.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/trump.mp4'
    },
    {
        id: 'ELON',
        name: 'Илон Маск',
        image: '/celebratory/Илон праздник Маск.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/elon.mp4'
    },
];

let remotePersonas = null;
let loadPromise = null;
const listeners = new Set();

export function getPersonas() {
    return remotePersonas || PERSONAS;
}

// Fetches the catalog once per page load (with retries and backoff inside
// apiGetWithRetry); if all attempts fail the static list stays and a later
// call may start over.
export function loadPersonas() {
    if (!loadPromise) {
        loadPromise = apiGetWithRetry('/celebs/catalog')
            .then(list => {
                if (Array.isArray(list) && list.length > 0) {
                    remotePersonas = list;
                    listeners.forEach(listener => listener());
                }
            })
            .catch(() => {
                loadPromise = null;
            });
    }
    return loadPromise;
}

function subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function usePersonas() {
    return useSyncExternalStore(subscribe, getPersonas, () => PERSONAS);
}

export function getPersonaById(id) {
    return getPersonas().find(p => p.id === id) || PERSONAS.find(p => p.id === id);
}

export function getOrderedPersonas(preSelectedId, personas = getPersonas()) {
    if (!preSelectedId) return personas;
    const selected = personas.find(p => p.id === preSelectedId);
    if (!selected) return personas;
    return [selected, ...personas.filter(p => p.id !== preSelectedId)];
}
